import { a } from "../utils";
import { ArtItem } from "../../models/ArtItem";
export const setSelectedArtItems = (obj: ArtItem[]) => a({ type: "SET_SELECTED_ART_ITEMS", obj });